import { render, staticRenderFns } from "./ApprovedConnection.vue?vue&type=template&id=e3ebd51a"
import script from "./ApprovedConnection.vue?vue&type=script&lang=js"
export * from "./ApprovedConnection.vue?vue&type=script&lang=js"
import style0 from "./ApprovedConnection.vue?vue&type=style&index=0&id=e3ebd51a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports